export default {"src":"/_next/static/media/overdraft_protection.c65edf23.svg","height":387,"width":464};